import { fetchPermissionsForRequesterForGivenContexts, listRole, Role, RealmA6bEnum } from '@goldcast/api/backend';
import logger from '@goldcast/logger';

const PAGE_LIMIT = 50;

const actions = {
  async getRolePermissionConfig({ commit, dispatch }, { orgId, userId }) {
    try {
      const response = await fetchPermissionsForRequesterForGivenContexts({
        body: {
          realm: 'studio_app',
          requester_id: userId,
          context: {
            organization: orgId
          }
        },
        queryParams: {}
      });

      commit('setPermissionConfig', response?.[0] || {});
      return response;
    } catch (error: any) {
      dispatch(
        'studioToast/triggerToast',
        {
          msg: error?.message || 'Error fetching user permissions',
          mode: 'error'
        },
        { root: true }
      );
      logger.warn('Error fetching user permissions', error);
    }
  },
  async fetchRoles({ commit, dispatch }) {
    commit('setIsLoadingRoles', true);

    try {
      let allRoles: Array<Role> = [];
      let next: string | null = null;

      let page = 1;

      do {
        const queryParams: any = { limit: PAGE_LIMIT, offset: (page - 1) * PAGE_LIMIT, ordering: '-name' };

        const response = await listRole({
          queryParams
        });

        const roles = response?.results || [];
        allRoles = [...allRoles, ...roles];

        next = response?.next || null;
        page++;
      } while (next !== null);

      const rolesMapByRealm = {} as Record<RealmA6bEnum, Array<Role>>;
      const supportedRealms: Array<RealmA6bEnum> = ['studio_app', 'event_app', 'content_lab'];

      supportedRealms.forEach(realm => {
        rolesMapByRealm[realm] = allRoles.filter(role => role.realm === realm);
      });

      commit('setRolesByRealm', rolesMapByRealm);
    } catch (error: any) {
      dispatch(
        'studioToast/triggerToast',
        {
          msg: error.message || 'Error fetching user roles',
          mode: 'error'
        },
        { root: true }
      );
      logger.error('Error fetching user roles', error);
    } finally {
      commit('setIsLoadingRoles', false);
    }
  }
};

export default actions;
